<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Alterar data de vencimento da mensalidade
          </h4>
        </div>
        <div class="modal-body--scrollable">
          <table class="table table-striped modal__table">
            <tbody>
              <tr>
                <th>Id</th>
                <td>{{ selectedBill.id }}</td>
              </tr>
              <tr>
                <th>Encargos sendo aplicados</th>
                <td>{{ selectedBill.apply_charges | formatBoolean }}</td>
              </tr>
              <tr>
                <th>Número da parcela</th>
                <td>{{ selectedBill.contract_installment }}</td>
              </tr>
              <tr>
                <th>Data de vencimento</th>
                <td>{{ selectedBill.due_date | formatDate }}</td>
              </tr>
              <tr>
                <th>Valor</th>
                <td>{{ selectedBill.amount_with_charges | formatCurrency }}</td>
              </tr>
            </tbody>
          </table>
          <div class="modal-body">
            <div v-if="inputError" class="alert alert-danger">
              {{ inputError }}
            </div>
            <p>Nova data de vencimento:</p>
            <date-picker v-model="selectedDate"
                         placeholder="Informe a nova data de vencimento"
                         :config="datePickerOptions"
            />
            <p class="modal-legend">
              A mensalidade terá seu pagamento atual cancelado e um outro gerado para a
              nova data.
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="changeBillDueDate">
            Salvar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
import 'moment/locale/pt-br';
import BillsService from 'services/BillsService';
import DatePicker from 'vue-bootstrap-datetimepicker';
import datePickerOptions from 'utils/DatePickerOptions';

export default {
  data() {
    return {
      selectedDate: null,
      inputError: null,
      datePickerOptions,
    };
  },
  components: {
    DatePicker,
  },
  computed: {
    ...mapState([
      'selectedBill',
    ]),
    tomorrow() {
      return moment(new Date()).add(1, 'd');
    },
    actualDate() {
      const currentDueDate = moment(this.selectedBill.due_date);
      if (currentDueDate.isBefore(this.tomorrow)) return this.tomorrow.format('DD/MM/YYYY');
      return currentDueDate.format('DD/MM/YYYY');
    },
  },
  mounted() {
    this.selectedDate = this.actualDate;
  },
  methods: {
    ...mapActions([
      'loadStudentBills',
    ]),
    validateSelectedDate() {
      const selectedDueDate = moment(this.selectedDate, 'DD/MM/YYYY');
      if (!selectedDueDate.isValid()) {
        this.inputError = 'A data informada não é válida';
        return false;
      }
      if (selectedDueDate.isBefore(this.tomorrow)) {
        this.inputError = 'A nova data de vencimento não pode ser igual ou anterior a hoje';
        return false;
      }
      if (selectedDueDate.isSame(moment(this.selectedBill.due_date))) {
        this.inputError = 'A nova data de vencimento não pode ser igual à atual';
        return false;
      }
      return true;
    },
    changeBillDueDate() {
      if (!this.validateSelectedDate()) return;

      this.$loader.show();
      BillsService.changeBillDueDate(this.selectedBill.id, moment(this.selectedDate, 'DD/MM/YYYY').format('YYYY-MM-DD'))
        .then((response) => {
          this.loadStudentBills();
          this.$alert.notifySuccess(response.message);
          this.$emit('close');
        })
        .catch(({ body }) => {
          this.inputError = `Erro ao alterar a data de vencimento: ${body.message}`;
        })
        .finally(() => this.$loader.hide());
    },
  },
};
</script>
